import { create } from 'zustand';
import { deviceApi } from '../api/device.api';
import { DeviceType } from '../models/device';

type Counts = Partial<Record<DeviceType, number>>;

interface DevicesStore {
  counts: Counts;
  fetchCounts: () => Promise<void>;
  setCount: (type: DeviceType, count: number) => void;
}

const useDevicesStore = create<DevicesStore>()((set) => ({
  counts: {},
  fetchCounts: async () => {
    const types = [DeviceType.WEATHER, DeviceType.GEO];
    const results = await Promise.allSettled(types.map((type) => deviceApi.countByType(type)));
    const counts: Counts = {};
    results.forEach((r, i) => {
      if (r.status === 'fulfilled') counts[types[i]] = r.value;
    });
    set((s) => ({ counts: { ...s.counts, ...counts } }));
  },
  setCount: (type, count) => set((s) => ({ counts: { ...s.counts, [type]: count } })),
}));

export default useDevicesStore;
